import styled from 'styled-components';

export const MouseStyle = styled.div`
  @mixin bgGradient {
    background: #4873ff
      linear-gradient(
        transparent 0%,
        transparent 50%,
        #ffffff 50%,
        #ffffff 100%
      );
  }
    @include bgGradient;

    @media (max-width: 768px) {
      display: none;
    }

    position: relative;
    width: 32px;
    height: 48px;
    border-radius: 100px;
    background-size: 100% 200%;
    animation: colorSlide 5s linear infinite, nudgeMouse 5s ease-out infinite;
    margin: 0 auto;
    margin-bottom: 30px;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }

    &:before {
      width: 26px;
      height: 42px;
      background-color: #2253f5;
      border-radius: 100px;
    }

    &:after {
      background-color: #ffffff;
      width: 6px;
      height: 6px;
      border-radius: 100%;
      animation: trackBallSlide 5s linear infinite;
    }
  }

  @keyframes colorSlide {
    0% {
      background-position: 0% 100%;
    }
    20% {
      background-position: 0% 0%;
    }
    21% {
      background-color: #4873ff;
    }
    29.99% {
      background-color: #ffffff;
      background-position: 0% 0%;
    }
    30% {
      background-color: #4873ff;
      background-position: 0% 100%;
    }
    50% {
      background-position: 0% 0%;
    }
    51% {
      background-color: #4873ff;
    }
    59% {
      background-color: #ffffff;
      background-position: 0% 0%;
    }
    60% {
      background-color: #4873ff;
      background-position: 0% 100%;
    }
    80% {
      background-position: 0% 0%;
    }
    81% {
      background-color: #4873ff;
    }
    90%,
    100% {
      background-color: #ffffff;
    }
  }

  @keyframes trackBallSlide {
    0% {
      opacity: 1;
      transform: scale(1) translateY(-12px);
    }
    6% {
      opacity: 1;
      transform: scale(0.9) translateY(12px/4);
    }
    14% {
      opacity: 0;
      transform: scale(0.4) translateY(12px * 2);
    }
    15%,
    19% {
      opacity: 0;
      transform: scale(0.4) translateY(-12px);
    }
    28%,
    29.99% {
      opacity: 1;
      transform: scale(1) translateY(-12px);
    }
    30% {
      opacity: 1;
      transform: scale(1) translateY(-12px);
    }
    36% {
      opacity: 1;
      transform: scale(0.9) translateY(12px/4);
    }
    44% {
      opacity: 0;
      transform: scale(0.4) translateY(12px * 2);
    }
    45%,
    49% {
      opacity: 0;
      transform: scale(0.4) translateY(-12px);
    }
    58%,
    59.99% {
      opacity: 1;
      transform: scale(1) translateY(-12px);
    }
    60% {
      opacity: 1;
      transform: scale(1) translateY(-12px);
    }
    66% {
      opacity: 1;
      transform: scale(0.9) translateY(12px/4);
    }
    74% {
      opacity: 0;
      transform: scale(0.4) translateY(12px * 2);
    }
    75%,
    79% {
      opacity: 0;
      transform: scale(0.4) translateY(-12px);
    }
    88%,
    100% {
      opacity: 1;
      transform: scale(1) translateY(-12px);
    }
  }

  @keyframes nudgeMouse {
    0% {
      transform: translateY(0);
    }
    20% {
      transform: translateY(8px);
    }
    30% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(8px);
    }
    60% {
      transform: translateY(0);
    }
    80% {
      transform: translateY(8px);
    }
    90% {
      transform: translateY(0);
    }
  }

  @keyframes nudgeText {
    0% {
      transform: translateY(0);
    }
    20% {
      transform: translateY(2px);
    }
    30% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(2px);
    }
    60% {
      transform: translateY(0);
    }
    80% {
      transform: translateY(2px);
    }
    90% {
      transform: translateY(0);
    }
  }

  @keyframes colorText {
    21% {
      color: #4873ff;
    }
    30% {
      color: #ffffff;
    }
    51% {
      color: #4873ff;
    }
    60% {
      color: #ffffff;
    }
    81% {
      color: #4873ff;
    }
    90% {
      color: #ffffff;
    }
`;
